import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var linealTagIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.283 11.802-.016-7.696-1.614 1.615.029 6.017-10.355 10.355-8.653-8.653L11.96 3.11l6.074.013 1.625-1.626-7.697-.016c-.41 0-.794.16-1.085.452L.45 12.36a1.519 1.519 0 0 0-.011 2.146l8.82 8.82a1.52 1.52 0 0 0 2.146-.01l10.429-10.43c.285-.285.449-.681.449-1.085"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.404 9.374-.012-.012a1.837 1.837 0 0 1 0-2.596l2.052-2.052a3.44 3.44 0 0 0-3.186.919 3.45 3.45 0 0 0 0 4.876 3.451 3.451 0 0 0 4.875 0 3.437 3.437 0 0 0 .919-3.187L17 9.374a1.838 1.838 0 0 1-2.597 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.82.872-.63.629-1.624 1.625-2.033 2.033-1.208 1.209-1.165 1.165a.751.751 0 0 0 0 1.062l.012.01a.752.752 0 0 0 1.06 0l1.166-1.164 1.208-1.21 2.039-2.038 1.619-1.62L24 .84a1.57 1.57 0 0 0-2.181.033"
})));

export { linealTagIcon as default };
//# sourceMappingURL=linealTagIcon.js.map
